export const PROFESSIONS = [
  'Student',
  'Scientist',
  'Engineer',
  'Manufacturer',
  'Academic',
  'Government',
  'Defense',
  'Marketing',
  'Law',
  'Health',
  'Other'
] as const;

export const INTERESTS = [
  'Engines',
  'Software',
  'Research',
  'Manufacturing',
  'Public Policy',
  'Climate',
  'Economics',
  'Health',
  'Other'
] as const;


// Type definitions for better type safety
export type Profession = typeof PROFESSIONS[number];
export type Interest = typeof INTERESTS[number]; 